import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const ModelBasedTestConfigCustomParametersDescription = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Set custom values for your parameters to override their default values during test runs.
    </Color>
  </Paragraph>

export default ModelBasedTestConfigCustomParametersDescription
